import React from 'react';
import { TrendPill, Sparkline, ArrowRightIcon } from './primitives';

// The headline story at the top of a Data tab: a money number, an optional trend
// + sparkline, and a sentence of context. The emotional hook. Shown directly (no
// number tween) so it stays correct as real data loads in asynchronously.
// metric: { value:number, format:(n)=>string, caption }
export const HeroInsight = ({ eyebrow, headline, sub, metric, trend, compare, spark, tone = 'teal', cta }) => {
  const display = metric ? (metric.format ? metric.format(metric.value) : Math.round(metric.value)) : null;
  return (
    <div className={`cd-hero cd-hero--${tone}`}>
      <div className="cd-hero-main">
        {eyebrow && <span className="cd-hero-eyebrow">{eyebrow}</span>}
        <h2 className="cd-hero-headline">{headline}</h2>
        {sub && <p className="cd-hero-sub">{sub}</p>}
        {cta && (
          <button type="button" className="cd-hero-cta" onClick={cta.onClick}>
            {cta.label} <ArrowRightIcon size={15} />
          </button>
        )}
      </div>
      {metric && (
        <div className="cd-hero-aside">
          <span className="cd-hero-metric">{display}</span>
          {metric.caption && <span className="cd-hero-caption">{metric.caption}</span>}
          {trend && (
            <span className="cd-hero-trendwrap">
              <TrendPill value={trend.value} goodWhenUp={trend.goodWhenUp !== false} />
              {compare && <span className="cd-hero-trendnote">{compare}</span>}
            </span>
          )}
          {spark && spark.length > 1 && (
            <div className="cd-hero-spark"><Sparkline data={spark} width={120} height={36} draw strokeWidth={2.5} /></div>
          )}
        </div>
      )}
    </div>
  );
};
